<template>
  <div id="new-user" class="content">
    <div class="section-title">
      <div class="row">
        <div class="col-md-6">
          <h3>{{ title }}</h3>
        </div>
        <div class="col-md-6">
          <div class="userLog_bread">
            <span v-if="userLogged">
              {{
                userLogged.comercialName
                  ? userLogged.comercialName
                  : userLogged.name + " " + userLogged.lastName
              }}
            </span>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <div class="block">
      <el-form
        :model="user"
        name="newPasswordUser"
        :rules="rules"
        status-icon
        ref="newPasswordUser"
      >
        <div class="row">
          <div class="col-lg-5">
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="user.password"
                autocomplete="off"
                placeholder="Contraseña"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-lg-5">
            <el-form-item prop="repeatPassword">
              <el-input
                type="password"
                v-model="user.repeatPassword"
                autocomplete="off"
                placeholder="Repetir contraseña"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-12 text-right">
            <el-button class="btn btn_secondary" @click="goRoute('user')">
              Volver
            </el-button>
            <el-button class="btn btn_gradient" @click="adminPassword">
              Guardar cambios
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
// Components
import UserService from "@/services/user.service";

import { mapState } from "vuex";
export default {
  name: "admin-password",
  computed: {
    ...mapState({
      userLogged: "user"
    })
  },
  data() {
    const passRule = (rule, value, callback) => {
      if (!value && rule.required === true) {
        callback(new Error("Por favor rellena este campo"));
      } else {
        if (value && value.length < 8) {
          callback(
            new Error("La contraseña debe tener como mínimo 8 caracteres")
          );
        } else if (this.user.repeatPassword) {
          this.$refs.newPasswordUser.validateField("repeatPassword");
          callback();
        } else {
          callback();
        }
      }
    };
    const repeatPassRule = (rule, value, callback) => {
      if (!value && rule.required === true) {
        callback(new Error("Por favor rellena este campo"));
      } else if (value !== this.user.password) {
        callback(new Error("Las contraseñas no coinciden"));
      } else {
        callback();
      }
    };

    return {
      title: "CAMBIO GENERAL DE CONTRASEÑA",
      user: {
        password: null,
        repeatPassword: null
      },
      rules: {
        password: {
          required: true,
          validator: passRule,
          trigger: "blur"
        },
        repeatPassword: {
          required: true,
          validator: repeatPassRule,
          trigger: "blur"
        }
      }
    };
  },
  mounted() {
    document.querySelector("#app").scrollTop = 0;
  },
  methods: {
    adminPassword() {
      this.$refs["newPasswordUser"].validate(valid => {
        if (valid) {
          UserService.adminPassword({
            params: { password: this.user.password }
          }).then(() => {
            this.$notify({
              title: "OK",
              message:
                "Se le ha enviado un email al usuario con su nueva contraseña",
              type: "success",
              duration: 3000
            });
            this.goRoute("user");
          });
        } else {
          return false;
        }
      });
    },
    goRoute(route) {
      this.$router.push({ name: route });
    }
  }
};
</script>

<style lang="scss" scoped>
#new-user {
  width: 100%;
  height: auto;
}

@media (max-width: 992px) {
  #new-user {
    .el-select {
      width: 100%;
    }
  }
}
</style>
